<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';

    defineProps<{
        ai: boolean;
    }>();
</script>
<template>
    <div
        class="inline-flex items-center gap-1 rounded-xs px-1.75 py-0.75 text-overline-xs"
        :class="
            ai
                ? 'bg-primary-acai-200 text-primary-blueberry'
                : 'bg-primary-avocado-50 text-primary-avocado'
        "
    >
        <slot />
    </div>
</template>
